<div class="min-h-screen bg-gray-100 flex flex-col">

  <!-- Header -->
  <div class="bg-white px-8 py-4 flex items-center justify-between shadow-sm">
    <img src="https://www.hubblehox.com/wp-content/uploads/2025/01/hubblehox-favicon.png?v=2" class="h-10 w-auto" alt="Logo" />
    <div *ngIf="user_name" class="flex items-center gap-2 text-sm text-[#212121]">
      <div class="w-8 h-8 rounded-full bg-[#EBF2FF] flex items-center justify-center">
        <svg class="w-4 h-4 text-[#3F41D1]" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
        </svg>
      </div>
      <span class="font-medium">{{ user_name }}</span>
    </div>
  </div>

  <!-- Body -->
  <div class="flex-1 flex items-center justify-center p-8">

    <!-- ─── STEP 1: Aadhaar Verification ─── -->
    <div *ngIf="step === 1" class="w-full max-w-5xl bg-[#EBF2FF] rounded-3xl p-8 flex gap-8 items-start">

      <!-- LEFT: QR + App Download -->
      <div class="flex-1 flex flex-col gap-5">

        <!-- QR Card -->
        <div class="bg-white rounded-2xl p-8 flex flex-col items-center gap-4">

          <!-- Pending: show QR -->
          <ng-container *ngIf="aadhaar_status === 'pending'">
            <img *ngIf="aadhaar_qr_image"
              [src]="'data:image/png;base64,' + aadhaar_qr_image"
              alt="Aadhaar QR Code"
              class="w-72 h-72 object-contain" />
            <div *ngIf="!aadhaar_qr_image"
              class="w-72 h-72 flex items-center justify-center bg-gray-50 rounded-xl text-gray-400 text-sm">
              QR code loading…
            </div>
          </ng-container>

          <!-- Failed: error state -->
          <ng-container *ngIf="aadhaar_status === 'failed'">
            <div class="w-72 h-72 flex flex-col items-center justify-center gap-4 bg-red-50 rounded-xl">
              <svg class="w-16 h-16 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              </svg>
              <p class="text-red-500 font-medium text-center">Verification failed.<br />Please try again.</p>
              <button type="button" (click)="retryAadhaar()"
                class="px-6 py-2 bg-[#3F41D1] text-white rounded-xl font-medium hover:opacity-90 transition">
                Retry
              </button>
            </div>
          </ng-container>

          <p class="font-bold text-xl text-[#212121] text-center">Scan to verify your Aadhaar</p>
          <p class="text-[#666666] text-sm text-center">Scan this QR using the mAadhaar App to verify your Aadhaar</p>

          <div *ngIf="aadhaar_status === 'pending'" class="flex items-center gap-2 text-[#3F41D1] text-sm animate-pulse">
            <svg class="w-4 h-4 animate-spin flex-shrink-0" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
            </svg>
            Waiting for verification…
          </div>
        </div>

        <!-- App Download -->
        <div class="flex flex-col gap-3">
          <p class="text-[#3F41D1] font-semibold text-base">Download the mAadhaar app on</p>
          <div class="flex gap-3">
            <a href="https://play.google.com/store/apps/details?id=in.gov.uidai.mAadhaarPlus"
              target="_blank"
              class="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-xl">
              <svg class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3.18 23.76c.3.17.65.2.98.09l11.65-6.72-2.62-2.62-10.01 9.25zm-1.44-20.2A1.5 1.5 0 001.5 4.8v14.4c0 .47.22.9.6 1.16l.09.06 8.07-8.07v-.19L1.74 3.56zm14.44 9.2l-2.72-2.72-2.72 2.72 2.72 2.72 2.72-2.72zm2.28-7.17l-3.6 2.08 2.62 2.62 1.02-.59c.9-.52.9-1.62 0-2.11z" />
              </svg>
              <div class="flex flex-col leading-tight">
                <span class="text-[10px] text-gray-300">GET IT ON</span>
                <span class="text-sm font-semibold">Google Play</span>
              </div>
            </a>
            <a href="https://apps.apple.com/in/app/maadhaar/id1435469222"
              target="_blank"
              class="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-xl">
              <svg class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98l-.09.06c-.22.14-2.19 1.28-2.17 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.77M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              <div class="flex flex-col leading-tight">
                <span class="text-[10px] text-gray-300">Download on the</span>
                <span class="text-sm font-semibold">App Store</span>
              </div>
            </a>
          </div>
        </div>

      </div>

      <!-- RIGHT: Stepper + Instructions -->
      <div class="w-72 flex-shrink-0 bg-white rounded-2xl p-6 flex flex-col gap-4">

        <!-- Step 1 – Active -->
        <div class="flex items-center gap-3">
          <div class="w-8 h-8 rounded-full bg-[#3F41D1] flex items-center justify-center flex-shrink-0">
            <span class="text-white font-semibold text-sm">1</span>
          </div>
          <span class="text-[#3F41D1] font-semibold">Aadhaar verification</span>
        </div>

        <!-- Connector -->
        <div class="w-px h-4 bg-gray-200 ml-4"></div>

        <!-- Step 2 – Inactive -->
        <div class="flex items-center gap-3">
          <div class="w-8 h-8 rounded-full border-2 border-gray-300 flex items-center justify-center flex-shrink-0">
            <span class="text-gray-400 font-semibold text-sm">2</span>
          </div>
          <span class="text-gray-400">Face verification</span>
        </div>

        <div class="border-t border-gray-200 my-1"></div>

        <!-- Instructions -->
        <div class="flex flex-col gap-3">
          <p class="text-[#212121] font-semibold text-sm">Instructions:</p>
          <ul class="flex flex-col gap-3 text-xs text-[#666666]">
            <li>
              <span class="font-semibold text-[#212121]">Face the camera directly</span><br />
              Keep your face centred and look straight into the lens — avoid tilting or turning your head
            </li>
            <li>
              <span class="font-semibold text-[#212121]">Use good lighting</span><br />
              Sit facing a light source. Avoid backlighting or shadows across your face
            </li>
            <li>
              <span class="font-semibold text-[#212121]">Remove obstructions</span><br />
              Take off sunglasses, caps, or masks. Prescription glasses are allowed
            </li>
            <li>
              <span class="font-semibold text-[#212121]">Stay still while capturing</span><br />
              Hold steady for 2–3 seconds after pressing capture for a sharp, clear image
            </li>
          </ul>
        </div>

      </div>
    </div>

    <!-- ─── STEP 2: Face Verification ─── -->
    <div *ngIf="step === 2" class="w-full max-w-3xl bg-white rounded-2xl shadow-2xl p-8">

      <div class="flex gap-8">

        <!-- LEFT: Camera -->
        <div class="flex-1 flex flex-col items-center gap-4">

          <!-- Camera / Preview -->
          <div class="relative w-72 h-72 bg-gray-900 rounded-2xl overflow-hidden">
            <video #videoEl autoplay playsinline
              class="w-full h-full object-cover"
              [style.transform]="'scaleX(-1)'"
              [style.display]="face_image_base64 ? 'none' : 'block'">
            </video>
            <img *ngIf="face_image_base64" [src]="face_image_base64" class="w-full h-full object-cover" alt="Captured face" />

            <!-- Oval guide overlay -->
            <div *ngIf="!face_image_base64" class="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div class="w-48 h-60 rounded-full border-[3px] border-[#3F41D1]"
                style="box-shadow: 0 0 0 9999px rgba(0,0,0,0.55)">
              </div>
            </div>
          </div>

          <!-- Hidden canvas for capture -->
          <canvas #canvasEl class="hidden"></canvas>

          <div class="text-center space-y-1">
            <p class="text-sm text-[#666666]">Align your face within the oval frame</p>
            <p class="text-sm text-[#666666]">Stay still while capturing</p>
          </div>

          <!-- Buttons -->
          <div class="flex items-center gap-3">
            <button *ngIf="!face_image_base64" type="button" (click)="captureImage()"
              class="flex items-center gap-2 px-8 py-3 bg-[#3F41D1] text-white rounded-xl font-medium hover:opacity-90 transition">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 15.2A3.2 3.2 0 018.8 12 3.2 3.2 0 0112 8.8a3.2 3.2 0 013.2 3.2 3.2 3.2 0 01-3.2 3.2m7.9-8.4-1.8-.8A2 2 0 0016.2 5H7.8A2 2 0 006 5.8L3.8 6.8A2 2 0 002 8.6V18a2 2 0 002 2h16a2 2 0 002-2V8.6a2 2 0 00-2.1-1.8z" />
              </svg>
              Capture
            </button>

            <ng-container *ngIf="face_image_base64">
              <button type="button" (click)="retakeFace()"
                class="px-6 py-3 border-2 border-[#3F41D1] text-[#3F41D1] rounded-xl font-medium hover:bg-[#EBF2FF] transition">
                Retake
              </button>
              <button type="button" (click)="submitFaceVerification()" [disabled]="face_loading"
                class="flex items-center gap-2 px-6 py-3 bg-[#3F41D1] text-white rounded-xl font-medium hover:opacity-90 transition disabled:opacity-60">
                <svg *ngIf="face_loading" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                </svg>
                {{ face_loading ? 'Verifying…' : (is_first_login ? 'Register Face' : 'Verify') }}
              </button>
            </ng-container>
          </div>

          <p *ngIf="face_error" class="text-red-500 text-sm text-center">{{ face_error }}</p>

        </div>

        <!-- RIGHT: Stepper + Instructions -->
        <div class="w-64 flex-shrink-0 flex flex-col gap-5">

          <!-- Steps -->
          <div class="flex flex-col gap-1">
            <!-- Step 1 – Done -->
            <div class="flex items-center gap-3">
              <div class="w-8 h-8 rounded-full bg-[#008A2E] flex items-center justify-center flex-shrink-0">
                <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z"
                    clip-rule="evenodd" />
                </svg>
              </div>
              <span class="text-[#008A2E] font-medium text-sm">Aadhaar verification</span>
            </div>
            <!-- Connector -->
            <div class="w-px h-4 bg-gray-200 ml-4"></div>
            <!-- Step 2 – Active -->
            <div class="flex items-center gap-3">
              <div class="w-8 h-8 rounded-full bg-[#3F41D1] flex items-center justify-center flex-shrink-0">
                <span class="text-white font-semibold text-sm">2</span>
              </div>
              <span class="text-[#212121] font-semibold">Face verification</span>
            </div>
          </div>

          <div class="border-t border-gray-200"></div>

          <!-- Instructions -->
          <div class="bg-[#EBF2FF] rounded-xl p-4 flex flex-col gap-3">
            <p class="text-[#212121] font-semibold text-sm">Instructions:</p>
            <ul class="flex flex-col gap-2 text-xs text-[#666666]">
              <li>
                <span class="font-semibold text-[#212121]">Face the camera directly</span><br />
                Keep your face centred and look straight into the lens — avoid tilting or turning your head
              </li>
              <li>
                <span class="font-semibold text-[#212121]">Use good lighting</span><br />
                Sit facing a light source. Avoid backlighting or shadows across your face
              </li>
              <li>
                <span class="font-semibold text-[#212121]">Remove obstructions</span><br />
                Take off sunglasses, caps, or masks. Prescription glasses are allowed
              </li>
              <li>
                <span class="font-semibold text-[#212121]">Stay still while capturing</span><br />
                Hold steady for 2–3 seconds after pressing capture for a sharp, clear image
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>
